import { render, staticRenderFns } from "./login3.vue?vue&type=template&id=1a613112&scoped=true&"
import script from "./login3.vue?vue&type=script&lang=js&"
export * from "./login3.vue?vue&type=script&lang=js&"
import style0 from "./login3.vue?vue&type=style&index=0&id=1a613112&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a613112",
  null
  
)

export default component.exports